<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->


<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->


  <!-- Custom js -->

    console.log("region " + pageRegion);
    console.log("pageLang " + pageLang);

// if(pageRegion === 'GB') {
//   $('#shopify-section-footer > footer > div > div > div > div:nth-child(4) > div > div > ul > li:nth-child(1)').hide();
//   document.querySelector('.list-menu').children[5].style.display = 'none';

// if (window.location.pathname === '/en-uk/pages/where-to-buy') {
//     window.location.href = 'https://diapergenie.com/en-uk/';
// }
// }

if(pageRegion=="CA" && pageLang=="fr" ) {
   $("a.menu-lv-1__action.header__menu-item").addClass("french-navigation");
  $(".list-menu .menu-lv-item:nth-child(5)").addClass("add-width");
  $(".list-menu .menu-lv-item:nth-child(7)").addClass("add-width");
}

if(pageRegion=="DE" || pageRegion=="FR" || pageRegion=="GB")
$("ul.list-menu li a").each(function() {
    var href = $(this).attr("href");
    if (href && href.includes("this-is-parenthood")) {
      $(this).parent().hide(); //
    }
  });


if(pageRegion === 'DE' || pageRegion === 'GB' || pageRegion === 'FR') {
 var useContentDiv = document.querySelector('.use-content');
  if (useContentDiv && useContentDiv.querySelectorAll('.step-item').length > 3) {
    var stepNumbers = useContentDiv.querySelectorAll('.step-item .step-number');
    stepNumbers.forEach(function(stepNumber) {
        stepNumber.classList.add('more-steps');
    });
  }
  document.querySelectorAll('.productView-image.fit-unset .productView-img-container img:not(.zoomImg)').forEach(element => {
    element.classList.add('int-card');
  });
   let socialIconsNav = document.querySelector(".social-icons-nav");
    if (socialIconsNav) {
        socialIconsNav.classList.add("social-europe");
        
        let firstLink = socialIconsNav.querySelector("a");
        if (firstLink) {
            firstLink.href = "https://www.instagram.com/diapergenieeurope/";
        }
    }
}

 const productInfoCard = document.querySelectorAll(".product-description");

productInfoCard.forEach(element => {
  if (pageRegion === 'GB') {
    element.classList.add('int-description');
  }
  else if (pageRegion === 'DE') {
    element.classList.add('de-description');
  }
  else if (pageRegion === 'FR') {
    element.classList.add('FR-description');
  }
});

var divs = document.getElementsByClassName("blog-summary"); 
var maxWords = 50; 
for (var i = 0; i < divs.length; i++) {
  var div = divs[i]; 
  var words = div.innerText.split(" "); 

  if (words.length > maxWords) {
    var limitedWords = words.slice(0, maxWords); 
    div.innerText = limitedWords.join(" ") + "..."; 
  }
}

if (document.documentElement.lang === 'fr') {
  const paragraph = document.querySelector('.subtext-video.rte p');

  if ( $(paragraph).length ){
    paragraph.classList.add('fr-width');
    
  }
}

if (
  window.location.pathname === '/de-de/pages/this-is-parenthood' &&
  window.location.hostname === 'diapergenie.com'
) {
  window.location.href = 'https://diapergenie.com/de-de';
}

if (
  window.location.pathname === '/en-uk/pages/this-is-parenthood' &&
  window.location.hostname === 'diapergenie.com'
) {
  window.location.href = 'https://diapergenie.com/en-uk';
}

if (
  window.location.pathname === '/fr-fr/pages/this-is-parenthood' &&
  window.location.hostname === 'diapergenie.com'
) {
  window.location.href = 'https://diapergenie.com/fr-fr';
}


// FUNCTION TO HIDE NAV ELEMENTS

if( pageRegion === "CA" && pageLang === "fr" ) {
   const socialIconsNav = document.querySelector('.social-icons-nav');
  if (socialIconsNav) {
    socialIconsNav.classList.add('region-ca-fr'); 
  }
}

if( pageRegion === "CA" || pageRegion === "US" ) {
  
  if ( $('[href*="/collections/products"]').length ) {
       $('[href*="/collections/products"]').remove();
  }

  // HIDE ON MOBILE MENU 
  document.addEventListener("DOMContentLoaded", function() {
    let style = document.createElement("style");
    style.textContent = "#MenuMobileListSection-menu > li:nth-child(4) { display: none; }";
    document.head.appendChild(style);
  });



}else{

    if ( $('[href*="/collections/product-page-pails"]').length ) {
         $('[href*="/collections/product-page-pails"]').remove();
    }

    if ( $('[href*="/collections/accessories"]').length ) {
         $('[href*="/collections/accessories"]').remove();
    }

    if ( $('[href*="/collections/refills"]').length ) {
         $('[href*="/collections/refills"]').remove();
    }


    // HIDE ON MOBILE MENU 
  document.addEventListener("DOMContentLoaded", function() {
    let style = document.createElement("style");
    style.textContent =`
        #MenuMobileListSection-menu > li:nth-child(1), 
        #MenuMobileListSection-menu > li:nth-child(2),
        #MenuMobileListSection-menu > li:nth-child(3) { 
            display: none; 
        }  
    `;
    document.head.appendChild(style);
  });

 


  //HIDE WARRANTY PAGE FORM INT MARKETS

}

